/* eslint-disable import/prefer-default-export, import/no-extraneous-dependencies */
import React from 'react';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { PersistGate } from 'redux-persist/es/integration/react';
// import { AuthProvider } from 'panna-auth';
import { AuthProvider } from '@panna/auth';
import '@panna/auth/dist/index.css';
import '@panna/pdffiller/dist/index.css';
import '@panna/sign/dist/index.css';

import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

import ReactDOM from 'react-dom/client';
import '@fontsource/lato';
import '@fontsource/montserrat';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { persistor, store } from './store';

export const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  // <React.StrictMode>
  <AuthProvider>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Toaster />
          <App />
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  </AuthProvider>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
